import { useState } from "react";
import { channelDetails } from "@/mocks/home";

export default function ChannelDetail() {
  const [activeId, setActiveId] = useState(channelDetails[0].id);
  const active = channelDetails.find((item) => item.id === activeId) ?? channelDetails[0];

  return (
    <section id="detail" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="text-xs md:text-sm font-semibold tracking-widest text-accent-700 uppercase">
            Channel Detail
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            渠道详解：用法、优点与注意事项
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            点击左侧渠道名称切换，查看每个渠道的具体操作方式、常见优点、需要留意的问题以及典型文件格式。切换只作用于本页内容。
          </p>
        </div>

        <div className="mt-10 flex flex-col lg:flex-row gap-5">
          <div
            role="tablist"
            aria-label="渠道选择"
            className="flex lg:flex-col gap-2 overflow-x-auto lg:overflow-visible pb-1 lg:pb-0 lg:w-64 shrink-0"
          >
            {channelDetails.map((item) => {
              const isActive = item.id === activeId;
              return (
                <button
                  key={item.id}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  onClick={() => setActiveId(item.id)}
                  className={`flex items-center gap-2.5 px-4 py-3 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-50 text-foreground-700 hover:bg-background-200 border border-background-200"
                  }`}
                >
                  <i className={`${item.icon} text-base`}></i>
                  {item.name}
                </button>
              );
            })}
          </div>

          <div className="flex-1 rounded-lg border border-background-200 bg-background-50 p-5 md:p-8">
            <div className="flex items-center gap-3">
              <span className="w-12 h-12 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center">
                <i className={`${active.icon} text-2xl`}></i>
              </span>
              <div>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">{active.name}</h3>
                <p className="text-xs md:text-sm text-foreground-500">用法说明与常见关注点</p>
              </div>
            </div>

            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-700">{active.usage}</p>

            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-5">
              <div className="rounded-lg bg-secondary-50 border border-secondary-200 p-4">
                <h4 className="flex items-center gap-2 font-heading text-base font-semibold text-secondary-900">
                  <i className="ri-thumb-up-line"></i>
                  常见优点
                </h4>
                <ul className="mt-3 space-y-2">
                  {active.pros.map((pro) => (
                    <li key={pro} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-check-double-line text-secondary-600 mt-0.5"></i>
                      <span>{pro}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="rounded-lg bg-primary-50 border border-primary-200 p-4">
                <h4 className="flex items-center gap-2 font-heading text-base font-semibold text-primary-900">
                  <i className="ri-error-warning-line"></i>
                  注意事项
                </h4>
                <ul className="mt-3 space-y-2">
                  {active.cons.map((con) => (
                    <li key={con} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-subtract-line text-primary-600 mt-0.5"></i>
                      <span>{con}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="mt-5 flex items-start gap-3 rounded-lg bg-background-100 border border-background-200 p-4">
              <i className="ri-file-copy-2-line text-lg text-accent-700 mt-0.5"></i>
              <p className="text-sm text-foreground-700">
                <span className="font-semibold text-foreground-900">常见格式：</span>
                {active.formats}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}